<section class="flex flex-col">
  <!-- The container can hold an Apex chart, a table with aggregated data, or any other relevant information as required -->
  @if (!isNoContent) {
    <ng-content></ng-content>
  }
  @if (loading) {
    <div class="flex h-full min-h-[100px] items-center justify-center">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  }
</section>
